import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/service/loader.service';
import { CommonService } from 'src/app/service/common.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { RolesEnum } from 'src/app/service/enums/role.enum';
import { RequestStatusEnum } from 'src/app/service/enums/requestStatus.enum';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-working-station-live',
  templateUrl: './working-station-live.component.html',
  styleUrls: ['./working-station-live.component.scss']
})
export class WorkingStationLiveComponent extends BaseComponent implements OnInit {
  
  dtOptions: any = {};
  ordersList: any[];
  searchText: string;
  implementationType: number;
  totalActiveWorking:number;
  totalCompleted:number;
  totalPending:number;
  requestStatusEnum: any;

    @ViewChild(DataTableDirective, { static: false })
    private datatableElement: DataTableDirective;
  
    @ViewChild('dtElement') table: ElementRef;

  chartData: number[]=[];
  public barChartLabelsInWork:string[] =[]
  public barChartDataInWork:any[] =[];
  public barChartColorsInWork:Array<any> = [];

  public barChartLabelsReturn:string[] =[]
  public barChartDataReturn:any[] =[];
  public barChartColorsReturn:Array<any> = [];

  public barChartType:string = 'horizontalBar';
  public barChartLegend:boolean = false;

  //   public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };
  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 6,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

 constructor(private commonService: CommonService,
             private loaderService: LoaderService
            ) 
            
            { 
              super();
              this.requestStatusEnum = RequestStatusEnum;
              
             }

  ngOnInit(): void {
    console.log("ngoninit");
    const that = this;
    //this.GetOrderList();
    this.barChartDataInWork =[];
    this.barChartLabelsInWork=[];
    this.barChartDataInWork=[];
    this.barChartDataReturn =[];
    this.barChartLabelsReturn=[];
    this.barChartDataReturn=[];
      this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      lengthMenu: [10, 50, 100, 1000],
      serverSide: true,
      processing: true,
      search: {
        return: true
      },
      searchDelay: 500,
      order: [[0, "desc"]],
      dom: 'lBfrtip',
      columns: [
        { orderable: true },
        { orderable: true },       
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
        { orderable: true, },
      ],
      language: {
        url: 'assets/datatable-i18n/' + that.appTranslateService.getCurrentLang() + '.json'
      },
      buttons: [
        // {
        //   text: that.appTranslateService.getTranslate('refresh'),
        //   key: '1',
        //   className: 'datatable-export-excel-btn',
        //   action: function (e, dt, node, config) {
        //     that.rerender();
        //   }
        // },
        {
          text: this.lang==="en"? "Export Excel":"تصدير إكسل",//that.appTranslateService.getTranslate('exportExcel'),
          key: '2',
          className: 'datatable-export-excel-btn',
          action: function (e, dt, node, config) {
           that.exportToExcel();
          }
        },
       
      ],
       ajax: (dataTablesParameters: any, callback) => {
        //console.log("order.column Work station 1",dataTablesParameters.order.column);
       
        
        that.commonService.GetOrdersListWorkStation(dataTablesParameters).subscribe(
          res => {
            if (res.successed) {
               console.log("res",res);
              this.ordersList =  res.data.data.workStationTable;
               this.chartData=[];
               this.barChartLabelsInWork=[];
               this.barChartLabelsReturn=[];
                
                for (let i = 0; i <  res.data.data.inWorks.length; i++) {
                
                    this.barChartColorsInWork=[{backgroundColor:'#92be8eff'}] ;
                    this.barChartLabelsInWork.push(res.data.data.inWorks[i].employeeName)                    
                    this.chartData.push(res.data.data.inWorks[i].workCount)
                } 

                this.barChartDataInWork=[{data:this.chartData,label:this.lang==="en"? "In work":"قيد العمل"}];
               // console.log("this.barChartLabelsInWork",this.barChartLabelsInWork);
              //  console.log("this.barChartDataInWork",this.barChartDataInWork);
                
                this.chartData=[];
                for (let i = 0; i <  res.data.data.returneds.length; i++) {
                  
                    this.barChartColorsReturn=[{backgroundColor:'#6a7969ff'}] ;
                    this.barChartLabelsReturn.push(res.data.data.returneds[i].employeeName)
                    this.chartData.push(res.data.data.returneds[i].returnCount)
                }
              this.barChartDataReturn=[{data:this.chartData,label:this.lang==="en"? "Return":"الإعادة"}];

              this.totalActiveWorking=res.data.data.totalActiveWorking;           
              this.totalPending=res.data.data.totalPending;
              this.totalCompleted=res.data.data.totalCompleted;

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsFiltered,
                data: []
              });
              that.loaderService.hide();
            }
            else {
              that.loaderService.hide();
              that.toastrAlertService.errorToastr(res.errorMessage);
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            }
          },
          error => {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            that.loaderService.hide();
            if (typeof error.error !== "undefined") {
              that.toastrAlertService.errorToastr(that.appTranslateService.getTranslate(error.error));
            }
          }
        )

      }
     
    };

  }
  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.appTranslateService.getTranslate("orders"));
    /* save to file */
    XLSX.writeFile(wb, this.appTranslateService.getTranslate("orders") + '.xlsx');
  }


  public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      console.log(e);
    }
  goToOrderDetails(order) {
      if (order.createdBy === this.userprofile.id || order.userId === this.userprofile.id || this.userProfileService.isRoleExists(RolesEnum.SuperAdmin)|| this.userProfileService.isRoleExists(RolesEnum.Repaid)) {
        // this.router.navigate(["/order/orderDetails/" + order.requestId]);
        window.open("/order/orderDetails/" + order.requestId);
      }
    }

  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload();
    });
  } 
}
